import { mapGetters } from "vuex";

export const cadastroEmpresaCopiaMixin = {
  computed: {
    ...mapGetters(["currentUser", "empresaContexto", "empresas"]),
    empresasFiliaisCadastro() {
      const grupoId = Number(this.empresaContexto?.id_grupo_empresa || 0);
      const empresaAtualId = Number(this.empresaContexto?.id_empresa || 0);

      return (this.empresas || [])
        .filter(
          (empresa) =>
            grupoId > 0 &&
            Number(empresa.id_grupo_empresa) === grupoId &&
            Number(empresa.id_empresa) !== empresaAtualId
        )
        .sort((a, b) =>
          this.nomeEmpresaCadastro(a).localeCompare(this.nomeEmpresaCadastro(b))
        );
    },
    podeCopiarCadastrosEmpresa() {
      const admin = [true, 1, "1", "true"].includes(this.currentUser?.admin);

      return (
        admin &&
        Number(this.empresaContexto?.id_grupo_empresa || 0) > 0 &&
        this.empresasFiliaisCadastro.length > 0
      );
    },
  },
  methods: {
    nomeEmpresaCadastro(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa || ""}`
      );
    },
  },
};
